/**
 * Media URL utility
 * Uses Cloudflare R2 CDN if VITE_CDN_URL is set, otherwise falls back to local /media/
 */

const CDN_URL = import.meta.env.VITE_CDN_URL as string | undefined

/**
 * Get the full URL for a media asset
 * @param path - The path relative to media folder (e.g., "logos/company-logo-main.png")
 * @returns Full URL to the media asset
 */
export function getMediaUrl(path: string): string {
  // Remove leading slash if present
  const cleanPath = path.startsWith('/') ? path.slice(1) : path

  // Remove "media/" prefix if present (for backwards compatibility)
  const relativePath = cleanPath.startsWith('media/') ? cleanPath.slice(6) : cleanPath

  if (CDN_URL) {
    // Use CDN URL (remove trailing slash if present)
    const baseUrl = CDN_URL.endsWith('/') ? CDN_URL.slice(0, -1) : CDN_URL
    return `${baseUrl}/${relativePath}`
  }

  // Fallback to local media folder
  return `/media/${relativePath}`
}

/**
 * Shorthand for common media paths
 */
export const media = {
  logo: (name: string) => getMediaUrl(`logos/${name}`),
  product: (category: string, name: string) => getMediaUrl(`products/${category}/${name}`),
  about: (name: string) => getMediaUrl(`about/${name}`),
  company: (category: string, name: string) => getMediaUrl(`company/${category}/${name}`),
  video: (name: string) => getMediaUrl(`video/${name}`),
  news: (name: string) => getMediaUrl(`news/${name}`),
  icon: (name: string) => getMediaUrl(`icons/${name}`),
  homepage: (name: string) => getMediaUrl(`homepage/${name}`),
}
